import * as React from 'react';
import PropTypes from 'prop-types';

const SvgActivityRoutesNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M15.1 12.3a2 2 0 00-3.2 0 1.84 1.84 0 00-.32.66c-.01.01-.01.01 0 .02H4.74a3.24 3.24 0 110-6.48h8.28a2.24 2.24 0 00-.03-4.48H4.43a1.877 1.877 0 00-.33-.7 2.027 2.027 0 00-1.6-.8 2.027 2.027 0 00-1.6.8 1.997 1.997 0 000 2.4 2.027 2.027 0 001.6.8 2.027 2.027 0 001.6-.8c.15-.2.259-.428.32-.67.01-.01.02-.02.01-.03h8.59a1.24 1.24 0 01-.03 2.48H4.72a4.24 4.24 0 100 8.48h6.85c.056.261.168.507.33.72a2 2 0 103.2-2.4zM3.3 3.12a1.041 1.041 0 01-1.6 0 1 1 0 111.6 0zm11 10.98a1.04 1.04 0 01-1.6 0 1 1 0 111.6 0z"
        fill=""
      />
    </svg>
  )
);
SvgActivityRoutesNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgActivityRoutesNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgActivityRoutesNormalXsmall;
